import MasterProducts from './MasterProducts';

export default MasterProducts;

